const EVENT_SELECTED = 'selected';

/**
 *
 * @param {import('~/Autocomplete').AutocompleteDataset<any>[]} datasets
 * @returns
 */
export const withAutocomplete = (datasets) => (function withAutocomplete() {
	let _init;
	let _resolveDestroyed;
	const instance = new Promise(resolve => _init = resolve);
	const destroyed = new Promise(resolve => _resolveDestroyed = resolve);

	return {
		created() {
			this.$options.autocomplete = instance;
		},
		async mounted() {
			const { default: autocomplete } = await import('autocomplete.js');
			const { input } = this.$refs;

			const instance = autocomplete(input, {
				cssClasses: {
					noPrefix: true,
					dropdownMenu: 'city-chooser__dropdown',
					input: 'city-chooser__input',
					suggestions: 'city-chooser__suggestions',
					suggestion: 'city-chooser__suggestion',
					cursor: 'is-selected',
					empty: 'city-chooser__suggestions',
				},
				templates: {
					empty: () => 'По запросу ничего не найдено',
				},
			}, datasets);

			instance.on('autocomplete:selected', (...args) => this.$emit(EVENT_SELECTED, ...args));

			const unsubscribe = (() => {
				let initialValue;
				const saveValue = () => initialValue = input.value;
				const restoreValue = () => input.value = initialValue;

				instance.on('autocomplete:selected', saveValue);
				input.addEventListener('focus', saveValue);
				input.addEventListener('blur', restoreValue);

				return function unsubscribe() {
					instance.off('autocomplete:selected', saveValue);
					input.removeEventListener('focus', saveValue);
					input.removeEventListener('blur', restoreValue);
				}
			})();

			destroyed.then(function dispose() {
				instance.autocomplete.destroy();
				unsubscribe();
			});

			_init(instance.autocomplete);
		},
		destroyed() {
			_resolveDestroyed();
		},
	}
})();
